import { ADICIONAR_CIDADES } from './actionTypes';
import ICidade from '../interfaces/ICidade';

export const adicionarCidades = (cidades: ICidade[]) =>
  ({ type: ADICIONAR_CIDADES, state: cidades });